import isServerSide from '@helpers/misc/isServerSide'

export default function getJWTSavedData() {
  if (isServerSide()) return {}
  try {
    return JSON.parse(localStorage.getItem('justo_jwt_data')) || {}
  } catch (error) {
    return {}
  }
}
